export class SubscribedEvent {
  eventTypeName;
  revision;

  constructor({ eventTypeName = '', revision = '' }) {
    this.eventTypeName = eventTypeName;
    this.revision = revision;
  }
}
